/*
 * Rebuy Smart Cart -> header cart count bridge.
 *
 * Rebuy's Smart Cart replaces Dawn's drawer and mutates the cart through its
 * own API, so none of Dawn's cart JS runs and nothing ever refreshes
 * #cart-icon-bubble. Adding still looked fine because the add came from Dawn's
 * own product-form, which refreshes the bubble itself — but removing a line or
 * changing a quantity inside Rebuy's drawer left the header showing a stale
 * count until the next full page load.
 *
 * This re-renders the bubble through the Section Rendering API: the same
 * mechanism, and the same target, Dawn uses. The markup still belongs to
 * sections/cart-icon-bubble.liquid and its shared snippet — see failsafe
 * Topic 4 — so nothing here knows what a cart count looks like.
 *
 * Event names verified in the browser on 2026-08-06, adding from a section and
 * removing from Rebuy's drawer:
 *   rebuy:cart.add                      add only
 *   rebuy:cart.change                   add AND remove  <- the dependable one
 *   rebuy:smartcart.line-item-removed   remove
 *   rebuy:smartcart.line-item-decrease  quantity decrement
 * All four are listened for because Rebuy's set has changed between versions,
 * and all four are harmless duplicates: a removal fires three of them within a
 * few milliseconds and the debounce collapses them into one request.
 *
 * Inert when Rebuy is absent — the events simply never fire.
 */

(function () {
  var SECTION = 'cart-icon-bubble';
  var TARGET_ID = 'cart-icon-bubble';
  var DEBOUNCE = 150;

  var EVENTS = [
    'rebuy:cart.change',
    'rebuy:cart.add',
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.line-item-decrease',
  ];

  var timer = null;
  /* Requests are numbered so an earlier, slower response can never overwrite a
     later one — two quick removals would otherwise race and could leave the
     count showing the intermediate state. */
  var seq = 0;

  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }

  function refresh() {
    var target = document.getElementById(TARGET_ID);
    if (!target) return;

    var mine = ++seq;

    fetch(cartUrl() + '?section_id=' + SECTION)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (text) {
        if (mine !== seq) return; // a newer refresh has already started
        var source = new DOMParser().parseFromString(text, 'text/html').querySelector('.shopify-section');
        if (source) target.innerHTML = source.innerHTML;
      })
      .catch(function () {
        /* A failed refresh must never break the drawer. The count corrects
           itself on the next navigation. */
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, DEBOUNCE);
  }

  EVENTS.forEach(function (name) {
    document.addEventListener(name, schedule);
  });
})();
